module.exports = __webpack_public_path__ + "img/AI.b0f54081.svg";